import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareCursor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-cursor, cursor box, arrow"} maskId="square-filled-radius-0-stroke-1-IconSquareCursor"><path d="M3.25 3.25H20.75V11H19.75V4.25H4.25V19.75H11V20.75H3.25V3.25Z" fill="currentColor"/><path d="M22.8458 14.3541L10.7148 10.7148L14.3541 22.8458L17.3869 17.3869L22.8458 14.3541Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareCursor;
